const bls = {
  global: {
    fromDate: '2021',
    toDate: '2031',
    usageDisclaimer:
      'Where national data regarding earnings or employability within a particular field are cited, individual readers should take note that national averages may not accurately reflect the earnings of workers in their particular part of the country, and may include earners at all stages of their career, not just entry-level wages for recent graduates.',
  },
  healthcare: {
    growthPercent: {
      number: '13 percent',
      source: 'https://www.bls.gov/ooh/healthcare/home.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Healthcare Occupations.',
      updatedDate: 'October 2022',
    },
    growthJobs: {
      number: '2 million',
      source: 'https://www.bls.gov/ooh/healthcare/home.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Healthcare Occupations.',
      updatedDate: 'October 2022',
    },
    growthJobsInternal: {
      number: '16.97 million',
      source: 'https://www.bls.gov/emp/tables/emp-by-detailed-occupation.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Employment by major occupational group.',
      updatedDate: 'October 2022',
    },
  },

  associateDegreeValue: {
    // We should probably get rid of the stat below. It isn't used, and I could not find it on thelink provided
    jobs: {
      source: 'https://www.bls.gov/careeroutlook/2015/article/projections-occupation.htm',
      stat: '11 of the top 20 jobs typically requiring an associate degree or postsecondary non-degree award are in healthcare.',
      updatedDate: 'May 2020',
    },
    earningsVsNoDegree: {
      source: 'https://www.bls.gov/emp/chart-unemployment-earnings-education.htm',
      stat: 'Associate degree workers earn an average of $154 more each week than workers who only finished high school.',
      updatedDate: 'May 2021',
    },
    unemploymentRate: {
      // TODO this needs to be a complete sentence
      source: 'https://www.bls.gov/emp/chart-unemployment-earnings-education.htm',
      stat: 'Lower unemployment rate: 4.6% for associate degree holders compared to 6.2% for those with only a high school diploma.',
      updatedDate: 'May 2021',
    },
    general: {
      source: 'https://www.bls.gov/emp/chart-unemployment-earnings-education.htm',
      sourcePrefix:
        'Bureau of Labor Statistics. Employment Projections. Unemployment rates and earnings by educational attainment.',
      stat: 'According to the Bureau of Labor Statistics, having an associate degree can lead to higher earnings and a lower unemployment rate overall, compared to those with only a high school diploma or some college but no degree.',
      updatedDate: 'June 2020',
    },
  },

  hca: {
    general: {
      source: 'https://www.bls.gov/oes/current/oes433031.htm',
    },
    positions: {
      list: 'accounting assistant, accounting clerk and bookkeeping',
      source: 'https://www.onetonline.org/link/summary/43-3031.00',
      sourcePrefix: 'ONET Online Summary Report for Bookkeeping, Accounting, and Auditing Clerks.',
    },
    growthPercent: {
      fasterThanAverage: true,
      number: '',
      source: '',
      sourcePrefix: '',
      updatedDate: 'May 2021',
    },
    growthJobs: {
      number: '',
      source: '',
      sourcePrefix: '',
      updatedDate: 'May 2021',
    },
    payMedian: {
      number: '$45,560',
      source:
        'https://www.bls.gov/ooh/office-and-administrative-support/bookkeeping-accounting-and-auditing-clerks.htm#tab-5',
      sourcePrefix:
        'Bureau of Labor Statistics. Occupational Outlook Handbook. Bookkeeping, Accounting, and Auditing Clerks.',
      updatedDate: 'May 2021',
    },
    payBottom: {
      number: '$29,120',
      percentOfPopulation: '10',
      source:
        'https://www.bls.gov/ooh/office-and-administrative-support/bookkeeping-accounting-and-auditing-clerks.htm#tab-5',
      sourcePrefix:
        'Bureau of Labor Statistics. Occupational Outlook Handbook. Bookkeeping, Accounting, and Auditing Clerks.',
      updatedDate: 'May 2021',
    },
    payTop: {
      number: '$61,980',
      percentOfPopulation: '10',
      source:
        'https://www.bls.gov/ooh/office-and-administrative-support/bookkeeping-accounting-and-auditing-clerks.htm#tab-5',
      sourcePrefix:
        'Bureau of Labor Statistics. Occupational Outlook Handbook. Bookkeeping, Accounting, and Auditing Clerks.',
      updatedDate: 'May 2021',
    },
  },

  hhs: {
    general: {
      source: 'https://www.bls.gov/ooh/community-and-social-service/social-and-human-service-assistants.htm',
    },
    growthPercent: {
      fasterThanAverage: true,
      number: '12&nbsp;percent',
      source: 'https://www.bls.gov/ooh/community-and-social-service/social-and-human-service-assistants.htm#tab-6',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Social and Human Service Assistants.',
      updatedDate: 'May 2021',
    },
    growthJobs: {
      number: '52,400 ',
      source: 'https://www.bls.gov/ooh/community-and-social-service/social-and-human-service-assistants.htm#tab-1',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Social and Human Service Assistants.',
      updatedDate: 'February 2023',
    },
    payMedian: {
      number: '$37,610',
      source: 'https://www.bls.gov/oes/current/oes211093.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Employment and Wage Statistics.',
      updatedDate: 'May 2021',
    },
    payBottom: {
      number: '$27,910',
      percentOfPopulation: '10',
      source: 'https://www.bls.gov/oes/current/oes211093.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Employment and Wage Statistics.',
      updatedDate: 'May 2021',
    },
    payTop: {
      number: '$59,490',
      percentOfPopulation: '10',
      source: 'https://www.bls.gov/oes/current/oes211093.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Employment and Wage Statistics.',
      updatedDate: 'May 2021',
    },
  },

  him: {
    growthPercent: {
      fasterThanAverage: false,
      number: '7&nbsp;percent',
      source: 'https://www.bls.gov/ooh/healthcare/medical-records-and-health-information-technicians.htm#tab-1',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Medical Records Specialists.',
      updatedDate: 'May 2021 ',
    },
    growthJobs: {
      number: '12,300',
      source: 'https://www.bls.gov/ooh/healthcare/medical-records-and-health-information-technicians.htm#tab-6',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Medical Records Specialists.',
      updatedDate: 'May 2021',
    },
    payMedian: {
      number: '$46,660',
      source: 'https://www.bls.gov/ooh/healthcare/medical-records-and-health-information-technicians.htm#tab-5',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Medical Records Specialists.',
      updatedDate: 'May 2021',
    },
    payBottom: {
      number: '$29,340',
      percentOfPopulation: '10',
      source: 'https://www.bls.gov/ooh/healthcare/medical-records-and-health-information-technicians.htm#tab-5',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Medical Records Specialists.',
      updatedDate: 'May 2021',
    },
    payTop: {
      number: '$74,200',
      percentOfPopulation: '10',
      source: 'https://www.bls.gov/ooh/healthcare/medical-records-and-health-information-technicians.htm#tab-5',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Medical Records Specialists.',
      updatedDate: 'May 2021',
    },
  },

  hcm: {
    growthPercent: {
      fasterThanAverage: true,
      number: '28&nbsp;percent',
      source: 'https://www.bls.gov/ooh/management/medical-and-health-services-managers.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Medical and Health Services Managers.',
      updatedDate: 'May 2021',
    },
    growthJobs: {
      number: '139,600',
      source: 'https://www.bls.gov/ooh/management/medical-and-health-services-managers.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Medical and Health Services Managers.',
      updatedDate: 'May 2021',
    },
  },

  'hs-maa': {
    growthPercent: {
      fasterThanAverage: true,
      number: '8&nbsp;percent',
      source:
        'https://www.bls.gov/ooh/office-and-administrative-support/secretaries-and-administrative-assistants.htm#tab-6',
      sourcePrefix:
        'Bureau of Labor Statistics. Occupational Outlook Handbook. Secretaries and Administrative Assistants.',
      updatedDate: 'May 2021',
    },
    growthJobs: {
      number: '53,600',
      source:
        'https://www.bls.gov/ooh/office-and-administrative-support/secretaries-and-administrative-assistants.htm#tab-6',
      sourcePrefix:
        'Bureau of Labor Statistics. Occupational Outlook Handbook. Secretaries and Administrative Assistants.',
      updatedDate: 'May 2021',
    },
    payMedian: {
      number: '$37,450',
      source: 'https://www.bls.gov/oes/current/oes436013.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Employment and Wage Statistics.',
      updatedDate: 'May 2021',
    },
    payBottom: {
      number: '$29,040',
      percentOfPopulation: '10',
      source: 'https://www.bls.gov/oes/current/oes436013.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Employment and Wage Statistics.',
      updatedDate: 'May 2021',
    },
    payTop: {
      number: '$53,630',
      percentOfPopulation: '10',
      source: 'https://www.bls.gov/oes/current/oes436013.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Employment and Wage Statistics.',
      updatedDate: 'May 2021',
    },
  },

  mbcoa: {
    growthPercent: {
      fasterThanAverage: true,
      number: '8&nbsp;percent',
      source:
        'https://www.bls.gov/ooh/office-and-administrative-support/secretaries-and-administrative-assistants.htm#tab-6',
      sourcePrefix:
        'Bureau of Labor Statistics. Occupational Outlook Handbook. Secretaries and Administrative Assistants.',
      updatedDate: 'May 2021',
    },
    growthJobs: {
      number: '53,600',
      source:
        'https://www.bls.gov/ooh/office-and-administrative-support/secretaries-and-administrative-assistants.htm#tab-6',
      sourcePrefix:
        'Bureau of Labor Statistics. Occupational Outlook Handbook. Secretaries and Administrative Assistants.',
      updatedDate: 'May 2021',
    },
    payMedian: {
      number: '$37,450',
      source: 'https://www.bls.gov/oes/current/oes436013.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Employment and Wage Statistics.',
      updatedDate: 'May 2021',
    },
    payBottom: {
      number: '$29,040',
      percentOfPopulation: '10',
      source: 'https://www.bls.gov/oes/current/oes436013.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Employment and Wage Statistics.',
      updatedDate: 'May 2021',
    },
    payTop: {
      number: '$53,630',
      percentOfPopulation: '10',
      source: 'https://www.bls.gov/oes/current/oes436013.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Employment and Wage Statistics.',
      updatedDate: 'May 2021',
    },
  },

  'hs-mobs': {
    growthPercent: {
      fasterThanAverage: true,
      number: '8&nbsp;percent',
      source:
        'https://www.bls.gov/ooh/office-and-administrative-support/secretaries-and-administrative-assistants.htm#tab-6',
      sourcePrefix:
        'Bureau of Labor Statistics. Occupational Outlook Handbook. Secretaries and Administrative Assistants.',
      updatedDate: 'May 2021',
    },
    growthJobs: {
      number: '53,600',
      source:
        'https://www.bls.gov/ooh/office-and-administrative-support/secretaries-and-administrative-assistants.htm#tab-6',
      sourcePrefix:
        'Bureau of Labor Statistics. Occupational Outlook Handbook. Secretaries and Administrative Assistants.',
      updatedDate: 'May 2021',
    },
    payMedian: {
      number: '$37,450',
      source: 'https://www.bls.gov/oes/current/oes436013.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Employment and Wage Statistics.',
      updatedDate: 'May 2021',
    },
    payBottom: {
      number: '$29,040',
      percentOfPopulation: '10',
      source: 'https://www.bls.gov/oes/current/oes436013.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Employment and Wage Statistics.',
      updatedDate: 'May 2021',
    },
    payTop: {
      number: '$53,630',
      percentOfPopulation: '10',
      source: 'https://www.bls.gov/oes/current/oes436013.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Employment and Wage Statistics.',
      updatedDate: 'May 2021',
    },
  },

  'hs-pht': {
    growthPercent: {
      fasterThanAverage: false,
      number: '5&nbsp;percent',
      source: 'https://www.bls.gov/ooh/healthcare/pharmacy-technicians.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Pharmacy Technicians.',
      updatedDate: 'May 2021',
    },
    growthJobs: {
      number: '22,400',
      source: 'https://www.bls.gov/ooh/healthcare/pharmacy-technicians.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Pharmacy Technicians.',
      updatedDate: 'May 2021',
    },
    payMedian: {
      number: '$36,740',
      source: 'https://www.bls.gov/ooh/healthcare/pharmacy-technicians.htm#tab-5',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Pharmacy Technicians.',
      updatedDate: 'May 2021',
    },
    payBottom: {
      number: '$28,740',
      percentOfPopulation: '10',
      source: 'https://www.bls.gov/ooh/healthcare/pharmacy-technicians.htm#tab-5',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Pharmacy Technicians.',
      updatedDate: 'May 2021',
    },
    payTop: {
      number: '$47,580',
      percentOfPopulation: '10',
      source: 'https://www.bls.gov/ooh/healthcare/pharmacy-technicians.htm#tab-5',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Pharmacy Technicians.',
      updatedDate: 'May 2021',
    },
  },

  da: {
    growthPercent: {
      fasterThanAverage: true,
      number: '8&nbsp;percent',
      source: 'https://www.bls.gov/ooh/healthcare/dental-assistants.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Dental Assistants.',
      updatedDate: 'May 2021',
    },
    growthJobs: {
      number: '30,100',
      source: 'https://www.bls.gov/ooh/healthcare/dental-assistants.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Dental Assistants.',
      updatedDate: 'May 2021',
    },
    payMedian: {
      number: '$38,660',
      source: 'https://www.bls.gov/oes/current/oes319091.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Employment and Wage Statistics.',
      updatedDate: 'May 2021',
    },
    payBottom: {
      number: '$29,580',
      percentOfPopulation: '10',
      source: 'https://www.bls.gov/oes/current/oes319091.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Employment and Wage Statistics.',
      updatedDate: 'May 2021',
    },
    payTop: {
      number: '$59,540',
      percentOfPopulation: '10',
      source: 'https://www.bls.gov/oes/current/oes319091.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Employment and Wage Statistics.',
      updatedDate: 'May 2021',
    },
    businessHours: {
      quote:
        'While many dentists have traditional daytime business hours, some offer extended schedules for patients’ convenience. As a result, the BLS notes that some dental assistants may work evenings or weekends, and they may be employed full-time or part-time.',
      source: 'https://www.bls.gov/ooh/healthcare/dental-assistants.htm#tab-1',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Dental Assistants.',
    },
    fdar: {
      source:
        'https://www.dalefoundation.org/Resources-And-State-Requirements/State-Dental-Assistant-Requirements/Florida',
      sourcePrefix: 'Florida Dental Assistant Requirements. The DALE Foundation.',
    },
  },

  ma: {
    growthPercent: {
      fasterThanAverage: true,
      number: '16&nbsp;percent',
      source: 'https://www.bls.gov/ooh/healthcare/medical-assistants.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Medical Assistants.',
      updatedDate: 'May 2021',
    },
    growthJobs: {
      number: '117,800',
      source: 'https://www.bls.gov/ooh/healthcare/medical-assistants.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Medical Assistants.',
      updatedDate: 'May 2021',
    },
    payMedian: {
      number: '$37,190',
      source: 'https://www.bls.gov/oes/current/oes319092.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Employment and Wage Statistics.',
      updatedDate: 'May 2021',
    },
    payBottom: {
      number: '$29,070',
      percentOfPopulation: '10',
      source: 'https://www.bls.gov/ooh/healthcare/medical-assistants.htm#tab-5',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Medical Assistants.',
      updatedDate: 'May 2021',
    },
    payTop: {
      number: '$48,170',
      percentOfPopulation: '10',
      source: 'https://www.bls.gov/ooh/healthcare/medical-assistants.htm#tab-5',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Medical Assistants.',
      updatedDate: 'May 2021',
    },
  },

  na: {
    growthPercent: {
      fasterThanAverage: false,
      number: '5&nbsp;percent',
      source: 'https://www.bls.gov/ooh/healthcare/nursing-assistants.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Nursing Assistants and Orderlies.',
      updatedDate: 'May 2021',
    },
    growthJobs: {
      number: '64,900 ',
      source: 'https://www.bls.gov/ooh/healthcare/nursing-assistants.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Nursing Assistants and Orderlies.',
      updatedDate: 'May 2021',
    },
    payMedian: {
      number: '$30,310',
      source: 'https://www.bls.gov/ooh/healthcare/nursing-assistants.htm#tab-5',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Nursing Assistants and Orderlies.',
      updatedDate: 'May 2021',
    },
    payBottom: {
      number: '$23,880',
      percentOfPopulation: '10',
      source: 'https://www.bls.gov/ooh/healthcare/nursing-assistants.htm#tab-5',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Nursing Assistants and Orderlies.',
      updatedDate: 'May 2021',
    },
    payTop: {
      number: '$44,240',
      percentOfPopulation: '10',
      source: 'https://www.bls.gov/ooh/healthcare/nursing-assistants.htm#tab-5',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Nursing Assistants and Orderlies.',
      updatedDate: 'May 2021',
    },
  },

  pct: {
    growthPercent: {
      fasterThanAverage: false,
      number: '5&nbsp;percent',
      source: 'https://www.bls.gov/ooh/healthcare/nursing-assistants.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Nursing Assistants and Orderlies.',
      updatedDate: 'May 2021',
    },
    growthJobs: {
      number: '64,900',
      source: 'https://www.bls.gov/ooh/healthcare/nursing-assistants.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Nursing Assistants and Orderlies.',
      updatedDate: 'May 2021',
    },
    payMedian: {
      number: '$30,310',
      source: 'https://www.bls.gov/ooh/healthcare/nursing-assistants.htm#tab-5',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Nursing Assistants and Orderlies.',
      updatedDate: 'May 2021',
    },
    payBottom: {
      number: '$23,880',
      percentOfPopulation: '10',
      source: 'https://www.bls.gov/ooh/healthcare/nursing-assistants.htm#tab-5',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Nursing Assistants and Orderlies.',
      updatedDate: 'May 2021',
    },
    payTop: {
      number: '$44,240',
      percentOfPopulation: '10',
      source: 'https://www.bls.gov/ooh/healthcare/nursing-assistants.htm#tab-5',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Nursing Assistants and Orderlies.',
      updatedDate: 'May 2021',
    },
  },

  ph: {
    growthPercent: {
      number: '10&nbsp;percent',
      fasterThanAverage: true,
      source: 'https://www.bls.gov/ooh/healthcare/phlebotomists.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Phlebotomists.',
      updatedDate: 'May 2021',
    },
    growthJobs: {
      number: '13,900',
      source: 'https://www.bls.gov/ooh/healthcare/phlebotomists.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Outlook Handbook. Phlebotomists.',
      updatedDate: 'May 2021',
    },
    payMedian: {
      number: '$37,380',
      source: 'https://www.bls.gov/oes/current/oes319097.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Employment and Wage Statistics.',
      updatedDate: 'May 2021',
    },
    payBottom: {
      number: '$28,990',
      percentOfPopulation: '10',
      source: 'https://www.bls.gov/oes/current/oes319097.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Employment and Wage Statistics.',
      updatedDate: 'May 2021',
    },
    payTop: {
      number: '$48,490',
      percentOfPopulation: '10',
      source: 'https://www.bls.gov/oes/current/oes319097.htm',
      sourcePrefix: 'Bureau of Labor Statistics. Occupational Employment and Wage Statistics.',
      updatedDate: 'May 2021',
    },
  },
}

bls.healthcare.growthJobsInternal.blurb = `Through ${bls.global.toDate}, the healthcare industry as a whole is estimated to have ${bls.healthcare.growthJobsInternal.number} open positions.{{shortcode: 'footnote', content: '${bls.healthcare.growthJobsInternal.sourcePrefix}', link: '${bls.healthcare.growthJobsInternal.source}'}}`

bls.healthcare.growthJobs.blurb = `The U.S Bureau of Labor Statistics predicts that the healthcare field is projected to add ${bls.healthcare.growthJobs.number} jobs through ${bls.global.toDate}.{{shortcode: 'footnote', content: '${bls.healthcare.growthJobs.sourcePrefix}', link: '${bls.healthcare.growthJobs.source}'}}`

bls.da.fdar.quote = `In Florida, a dental assistant with formal education is permitted to perform more duties than one with only on-the-job training.{{shortcode: 'footnote', content: '${bls.da.fdar.sourcePrefix}', link: '${bls.da.fdar.source}'}}`

bls.da.jobOutlookBlurb = `The BLS Occupational Outlook Handbook projects that America’s dental assistant job outlook will remain strong from ${bls.global.fromDate} through ${bls.global.toDate}. The BLS predicts ${bls.da.growthPercent.number} employment growth{{shortcode: 'footnote', content: '${bls.da.growthPercent.sourcePrefix}', link: '${bls.da.growthPercent.source}'}}, which is “much faster than the average” for all occupations.`

bls.hca.jobOutlookBlurb = `${bls.healthcare.growthJobsInternal.blurb} This means that healthcare-related employers like physicians' offices, hospitals, and other facilities are projected to need more professionals to fill accounting roles.`

bls.hcm.jobOutlookBlurb = `Employment in this field is projected to grow ${bls.hcm.growthPercent.number} (faster than average) from ${bls.global.fromDate} to ${bls.global.toDate}.{{shortcode: 'footnote', content: '${bls.hcm.growthPercent.sourcePrefix}', link: '${bls.hcm.growthPercent.source}'}} ${bls.healthcare.growthJobsInternal.blurb}`

bls.hhs.jobOutlookBlurb = `Employment in this field is projected to grow ${bls.hhs.growthPercent.number} (faster than average) from ${bls.global.fromDate} to ${bls.global.toDate}. In that span, ${bls.hhs.growthJobs.number} job openings are projected to be added.{{shortcode: 'footnote', content: '${bls.hhs.growthJobs.sourcePrefix}', link: '${bls.hhs.growthJobs.source}'}} ${bls.healthcare.growthJobsInternal.blurb}`

bls.him.jobOutlookBlurb = `After earning your degree in UMA’s health information management program, you might be glad to know that this field has been projected to grow faster than average &mdash; ${bls.him.growthPercent.number} (${bls.him.growthJobs.number} job openings).{{shortcode: 'footnote', content: '${bls.him.growthJobs.sourcePrefix}', link: '${bls.him.growthJobs.source}'}} ${bls.healthcare.growthJobsInternal.blurb}`

bls[
  'hs-maa'
].jobOutlookBlurb = `After earning your degree or diploma at UMA, you might be glad to know that field has been projected to grow faster than average &mdash; ${bls['hs-maa'].growthPercent.number} (${bls['hs-maa'].growthJobs.number} job openings).{{shortcode: 'footnote', content: '${bls['hs-maa'].growthJobs.sourcePrefix}', link: '${bls['hs-maa'].growthJobs.source}'}} ${bls.healthcare.growthJobsInternal.blurb}`

bls[
  'hs-mobs'
].jobOutlookBlurb = `After earning your degree or diploma in UMA’s medical office billing and specialist program, you might be glad to know that field has been projected to grow faster than average &mdash; ${bls['hs-mobs'].growthPercent.number} (${bls['hs-mobs'].growthJobs.number} job openings) to be precise.{{shortcode: 'footnote', content: '${bls['hs-mobs'].growthJobs.sourcePrefix}', link: '${bls['hs-mobs'].growthJobs.source}'}} ${bls.healthcare.growthJobsInternal.blurb}`

bls[
  'hs-pht'
].jobOutlookBlurb = `After earning your UMA Health Sciences – Pharmacy Technician associate degree, you might be glad to know that the field has been projected to grow faster than average &mdash; ${bls['hs-pht'].growthPercent.number} (${bls['hs-pht'].growthJobs.number} job openings).{{shortcode: 'footnote', content: '${bls['hs-pht'].growthJobs.sourcePrefix}', link: '${bls['hs-pht'].growthJobs.source}'}} ${bls.healthcare.growthJobsInternal.blurb}`

bls.ma.jobOutlookBlurb = `In addition to the variety of positions, employment in this field is projected to grow ${bls.ma.growthPercent.number} (faster than average) from ${bls.global.fromDate} to ${bls.global.toDate}. In that span, ${bls.ma.growthJobs.number} job openings are projected to be added.{{shortcode: 'footnote', content: '${bls.ma.growthJobs.sourcePrefix}', link: '${bls.ma.growthJobs.source}'}} ${bls.healthcare.growthJobsInternal.blurb}`

bls.mbcoa.jobOutlookBlurb = `In addition to having a wide variety of positions, employment in this field is projected to grow ${bls.mbcoa.growthPercent.number} (faster than average) from ${bls.global.fromDate} to ${bls.global.toDate}. In that span, ${bls.mbcoa.growthJobs.number} job openings are projected to be added. ${bls.healthcare.growthJobsInternal.blurb}`

bls.na.jobOutlookBlurb = `Employment in the nursing assistant field is projected to grow ${bls.na.growthPercent.number} (faster than average) from ${bls.global.fromDate} to ${bls.global.toDate}. This field is projected to add ${bls.na.growthJobs.number} job openings in that span.{{shortcode: 'footnote', content: '${bls.na.growthJobs.sourcePrefix}', link: '${bls.na.growthJobs.source}'}} ${bls.healthcare.growthJobsInternal.blurb}`

bls.pct.jobOutlookBlurb = `Employment for nursing assistants, under which patient care technician roles fall, is expected to grow ${bls.pct.growthPercent.number} (faster than average) from ${bls.global.fromDate} to ${bls.global.toDate}. This field is projected to add ${bls.pct.growthJobs.number} job openings through ${bls.global.toDate}.{{shortcode: 'footnote', content: '${bls.pct.growthJobs.sourcePrefix}', link: '${bls.pct.growthJobs.source}'}} ${bls.healthcare.growthJobsInternal.blurb}`

bls.ph.jobOutlookBlurb = `Employment in the Phlebotomy field is projected to grow ${bls.ph.growthPercent.number} (much faster than average) from ${bls.global.fromDate} to ${bls.global.toDate}. In fact, this field is projected to add ${bls.ph.growthJobs.number} job openings in that span.{{shortcode: 'footnote', content: '${bls.ph.growthJobs.sourcePrefix}', link: '${bls.ph.growthJobs.source}'}} ${bls.healthcare.growthJobsInternal.blurb}`

export default bls
